import Bold from './bold'
import Italic from './italic'
import UnderLine from './underline'
import Header from './header'
import OrderedList from './orderedList'
import UnorderedList from './unorderedList'
import CodeBlock from './codeBlock'
import Blockquote from './blockquote'
import Divider from './divider'
import Link from './link'
import Image from './image'
import StrikeThrough from './strikethrough'


export default {
    Bold,
    Italic,
    UnderLine,
    Header,
    OrderedList,
    UnorderedList,
    CodeBlock,
    Blockquote,
    Divider,
    Link,
    Image,
    StrikeThrough
}



// WEBPACK FOOTER //
// ./src/toolbar/buttons/index.ts